import { useSelection } from '@/view/fleet/selection/SelectionContext';
import { useEquipmentTimeZone } from './useEquipmentTimeZone';

export function useSelectedEquipmentTimeZone() {
  const { selected } = useSelection();
  return useEquipmentTimeZone(selected);
}
